"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _buttonModule = _interopRequireDefault(require("./sass/button.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LinkButton = function LinkButton(_ref) {
  var _buttonClasses, _iconClassess;

  var className = _ref.className,
      href = _ref.href,
      children = _ref.children,
      icon = _ref.icon,
      color = _ref.color,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      fullWidthMobile = _ref.fullWidthMobile,
      tabIndex = _ref.tabIndex,
      target = _ref.target,
      to = _ref.to,
      onClick = _ref.onClick;
  var buttonClasses = (_buttonClasses = {}, _defineProperty(_buttonClasses, _buttonModule.default.global, true), _defineProperty(_buttonClasses, _buttonModule.default.linkbutton, true), _defineProperty(_buttonClasses, _buttonModule.default.primary, color === 'primary'), _defineProperty(_buttonClasses, _buttonModule.default.secondary, color === 'secondary'), _defineProperty(_buttonClasses, _buttonModule.default.ghost, color === 'ghost'), _defineProperty(_buttonClasses, _buttonModule.default.elementbase, color === 'elementbase'), _defineProperty(_buttonClasses, _buttonModule.default.link, color === 'link'), _defineProperty(_buttonClasses, _buttonModule.default.bluelegacy, color === 'bluelegacy' || color === 'primarylegacy'), _defineProperty(_buttonClasses, _buttonModule.default.greenlegacy, color === 'greenlegacy' || color === 'secondarylegacy'), _defineProperty(_buttonClasses, _buttonModule.default.danger, color === 'danger' || color === 'red' || color === 'redlegacy'), _defineProperty(_buttonClasses, _buttonModule.default.disabled, disabled), _defineProperty(_buttonClasses, _buttonModule.default.block_mobile, fullWidthMobile), _defineProperty(_buttonClasses, _buttonModule.default.display_block, fullWidth), _defineProperty(_buttonClasses, className, className), _buttonClasses);
  var iconClassess = (_iconClassess = {
    icon: true
  }, _defineProperty(_iconClassess, "".concat(className, "__icon"), className), _defineProperty(_iconClassess, _buttonModule.default.children_icon, icon), _iconClassess);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, href ? /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    target: target,
    onClick: onClick,
    className: (0, _classnames.default)(buttonClasses)
  }, icon ? /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(iconClassess)
  }, children) : /*#__PURE__*/_react.default.createElement("span", {
    className: _buttonModule.default.children
  }, children)) : /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
    className: (0, _classnames.default)(buttonClasses),
    disabled: disabled,
    to: to,
    tabIndex: tabIndex,
    target: target
  }, icon ? /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(iconClassess)
  }, children) : /*#__PURE__*/_react.default.createElement("span", {
    className: _buttonModule.default.children
  }, children)));
};

LinkButton.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(['primary', 'secondary', 'ghost', 'elementbase', 'link', 'bluelegacy', 'primarylegacy', 'greenlegacy', 'secondarylegacy', 'danger', 'red', 'redlegacy']),
  disabled: _propTypes.default.bool,
  fullWidth: _propTypes.default.bool,
  fullWidthMobile: _propTypes.default.bool,
  href: _propTypes.default.string,
  icon: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  tabIndex: _propTypes.default.string,
  target: _propTypes.default.string,
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
};
LinkButton.defaultProps = {
  children: 'Label',
  className: 'custom-className',
  color: 'primary',
  disabled: false,
  icon: null,
  fullWidth: false,
  fullWidthMobile: false,
  tabIndex: '0',
  to: null,
  href: null,
  target: '_self',
  onClick: function onClick() {}
};
var _default = LinkButton;
exports.default = _default;